/*
 * @Author       : aa
 * @Date         : 2020-09-10 13:26:47
 * @Description  : file content
 * @FilePath     : \vue-gaokao-ebook\src\mixins\my_personal.js
 */
import high_school_subjcet from "../assets/js/subject-data.js"
export const resource = {
    data() {
        return {
            subject: []
        }
    },
    methods: {
      // 学科 数据
        subjects() {
            const hss = high_school_subjcet;
            let user_json = localStorage.getItem('userinfo');
            const user = JSON.parse(user_json);
            if(user_json == null || user_json == '') {
                return hss
            } else {
                // const usi = user.subjectIds.split(",");
                const usi = "9,10,11,12,13,14,15,16,17".split(","); // 放开所有的学科
                const subjects_obj = {};
                for(var i in hss){
                //j为数组索引
                    for(var j in usi) {
                        let val;
                        if(i == usi[j]) {
                            val = hss[i];
                            subjects_obj[i] = val;
                        }
                    }
                }
                this.tab = Object.keys(subjects_obj)[0];
                return subjects_obj;
            }
        },
    },
    created() {
        this.subject = this.subjects()
    }
}